import { cn } from "@/lib/cn";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface ListaItemsSkeletonProps {
  items?: number;
  /** "lista": ícono + 2 líneas (notificaciones, historial) · "burbujas": mensajes alternados (chat). */
  variante?: "lista" | "burbujas";
  className?: string;
}

/** Lista de elementos en carga (notificaciones, historial, chat). */
export function ListaItemsSkeleton({ items = 4, variante = "lista", className }: ListaItemsSkeletonProps) {
  return (
    <RegionCargando className={cn("flex flex-col", variante === "lista" ? "gap-1" : "gap-3", className)}>
      {Array.from({ length: items }, (_, i) =>
        variante === "lista" ? (
          <div key={i} className="flex items-start gap-3 rounded-lg p-2" aria-hidden="true">
            <Skeleton height={20} width={20} circle className="mt-0.5 shrink-0" />
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <Skeleton height={12} width={i % 2 === 0 ? "85%" : "70%"} />
              <Skeleton height={10} width="40%" />
            </div>
          </div>
        ) : (
          <div key={i} className={cn("flex items-end gap-2", i % 2 === 1 && "flex-row-reverse")} aria-hidden="true">
            <Skeleton height={28} width={28} circle className="shrink-0" />
            <div className={cn("flex max-w-[70%] flex-col gap-1.5", i % 2 === 1 ? "items-end" : "items-start")}>
              <Skeleton height={36} width={i % 3 === 0 ? 220 : 160} className="rounded-2xl" />
              <Skeleton height={9} width={60} />
            </div>
          </div>
        ),
      )}
    </RegionCargando>
  );
}
